// extracted by mini-css-extract-plugin
export default {"Oyster":"#C0C5C9","Bluecheese":"#615CFF","header":"Ge197d8 G481d88","headerTitle":"G9c5902","headerCta":"Ge77956","currentValue":"Ga17995"};